var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticStyle:{"margin-top":"50px"}},[_c('button',{staticClass:"btn_go",on:{"click":_vm.goMiniProject}},[_vm._v("前往小程序")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }